export default "__VITE_ASSET__D5ou$xhI__"